import { useState, useContext, useCallback } from "react";
import UserContext from "../context/user";
import { useQueryClient } from "@tanstack/react-query";
import { downloadBlob } from "../utils/download";

const API_ENDPOINTS = {
  "abbonamento-open": "/api/ecommerce/download-pdf-abbonamento-open",
  prenotazioni: "/api/ecommerce/download-pdf-prenotazioni",
};

export const usePdf = () => {
  const { callApi } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const queryClient = useQueryClient();

  const downloadPdf = async (data) => {
    const { type, barcode, code } = data;
    const pdfId = type === "abbonamento-open" ? barcode : code;
    const qd = queryClient.getQueryData([`pdf-${type}`, pdfId]);
    if (qd) {
      downloadBlob(qd, `${type}_${pdfId}.pdf`);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const bytes = await callApi(API_ENDPOINTS[type], {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
        body: JSON.stringify(
          type === "abbonamento-open"
            ? {
                barcode,
              }
            : {
                code,
              },
        ),
      });
      const blob = new Blob([bytes], { type: "application/pdf" });
      queryClient.setQueryData([`pdf-${type}`, pdfId], blob);
      downloadBlob(blob, `${type}_${pdfId}.pdf`);
    } catch (err) {
      setError(err.desc);
    } finally {
      setLoading(false);
    }
  };

  const clearError = useCallback(() => setError(null), []);

  return { downloadPdf, loading, error, clearError };
};
